import { Accept } from "react-dropzone";

export const CONTACT_PHONE_NUMBER = "(877) 417-8733";
export const HELP_EMAIL_ADDRESS = "help@covertree.com";
export const MAX_FILE_SIZE = 10 * 1024 ** 2;
export const ACCEPTED_FILE_TYPES: Accept = {
  "image/png": [".png"],
  "image/jpeg": [".jpg"],
  "image/gif": [".gif"],
  "application/pdf": [".pdf"],
  "application/msword": [".doc"],
  "application/vnd.ms-excel": [".xls"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [
    ".docx",
  ],
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
    ".xlsx",
  ],
};
